import { useRouteError } from 'react-router-dom'
import { DevError } from '@shopmuchmore/design-system'

export function RouterErrorBoundary() {
  const error = useRouteError() as Error
  return <DevError error={error} />
}
